<template>
  <default-step-container v-on="containerListeners" :required="false">
    <template #question>{{ question }}</template>
    <template #default>
      <table class="table">
        <tbody>
        <tr v-for="(item, i) in summaryItems" :key="i">
          <td style="width: 10%"><span class="text-success"><i class="fas fa-check"></i></span></td>
          <td class="text-end table-item" style="width: 40%;"><span class="fw-bold">{{ item.label }}</span></td>
          <td class="table-item" style="width: 40%; overflow-wrap: anywhere;">{{ item.value }}</td>
          <td class="text-end" style="width: 10%">
            <button
                type="button"
                class="btn btn-outline-secondary btn-sm"
                @click="$emit('go', item.step)">
              <i class="fas fa-edit"></i>
            </button>
          </td>
        </tr>
        </tbody>
      </table>
    </template>
  </default-step-container>
</template>
<script>
import DefaultStep from './DefaultStep'

export default {
  extends: DefaultStep,

  computed: {
    summaryItems () {
      return []
    }
  },
}
</script>
